export const moduleIdentifiers = {
  Ewa: 4,
};
